<template>
  <div style="overflow-x: hidden;">
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs headline="Bảng điều khiển" :link="[{ text: 'Dashboard', href: '/dashboard' }]" />
      </div>
    </div>
    <v-card class="mx-4 mb-6" outlined v-if="$auth.policies['task-list:list-latest-need-approve-import-order']">
      <v-card-title class="pr-0">
        <span class="ml-2 text-subtitle-2">Danh sách công việc ngày {{ dateNow }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-0" style=" overflow-x: auto;">
        <DashboardWorkList v-if="$auth.policies['task-list:list-latest-need-approve-import-order']" />
      </v-card-text>
      <v-card-actions class="pa-0">
        <v-spacer></v-spacer>
        <div class="px-6 pb-6" v-if="workList.length">
          <router-link style="text-decoration: none" to="/import-order?orderStatus=notApproved">
            <div class="sty_detail">
              Xem chi tiết
              <v-icon class="material-icon" color="primary">keyboard_arrow_right</v-icon>
            </div>
          </router-link>
        </div>
      </v-card-actions>
    </v-card>
    <!-- 2 -->
    <v-card outlined class="mx-4 mb-6" v-if="$auth.policies['statistic-list:list-psi']">
      <v-card-title class="pr-0">
        <span class="ml-2 text-subtitle-2">Tiến độ hoàn thành chỉ tiêu PSI {{ yearNow }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-3">
        <v-row class="ma-0">
          <ProgressInCompleting v-if="$auth.policies['statistic-list:list-psi']" />
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-0">
        <v-spacer></v-spacer>
        <div class="px-6 pb-6">
          <router-link style="text-decoration: none" to="/">
            <div class="sty_detail">
              Xem chi tiết
              <v-icon class="material-icon" color="primary">keyboard_arrow_right</v-icon>
            </div>
          </router-link>
        </div>
      </v-card-actions>
    </v-card>
    <!-- 3 -->
    <v-card outlined class="mx-4 mb-6" v-if="$auth.policies['statistic-list:list-producer-stat-day']">
      <v-card-title class="pr-0">
        <span class="ml-2 text-subtitle-2">Tồn ngày {{ dateNow }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <DashboardInventory v-if="$auth.policies['statistic-list:list-producer-stat-day']" />
      </v-card-text>
      <v-card-actions class="pa-0">
        <v-spacer></v-spacer>
        <div class="px-6 pb-6">
          <router-link style="text-decoration: none" to="/inventory-time-report">
            <div class="sty_detail">
              Xem chi tiết
              <v-icon class="material-icon" color="primary">keyboard_arrow_right</v-icon>
            </div>
          </router-link>
        </div>
      </v-card-actions>
    </v-card>
    <!-- 4 -->
    <v-card outlined class="mx-4 mb-6" v-if="$auth.policies['history-list:list-latest-history-import']">
      <v-card-title class="pr-0">
        <span class="ml-2 text-subtitle-2">Lịch sử làm việc trên hệ thống ngày {{ dateNow }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <DashboardWorkHistory v-if="$auth.policies['history-list:list-latest-history-import']" />
      </v-card-text>
      <v-card-actions class="pa-0">
        <v-spacer></v-spacer>
        <div class="px-6 pb-6">
          <router-link style="text-decoration: none" to="/history">
            <div class="sty_detail">
              Xem chi tiết
              <v-icon class="material-icon" color="primary">keyboard_arrow_right</v-icon>
            </div>
          </router-link>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import ProgressInCompleting from '@/modules/dashboard/ProgressInCompleting.vue'
import DashboardInventory from '@/modules/dashboard/DashboardInventory.vue'
import DashboardWorkHistory from '@/modules/dashboard/DashboardWorkHistory.vue'
import DashboardWorkList from '@/modules/dashboard/DashboardWorkList.vue'
import { mapState } from 'vuex'
export default {
  components: {
    Breadcrumbs,
    ProgressInCompleting,
    DashboardInventory,
    DashboardWorkHistory,
    DashboardWorkList
  },
  mounted() {
    const date = new Date()
    const options = { day: 'numeric', month: 'numeric', year: 'numeric' }
    const optionsYear = { year: 'numeric' }
    this.dateNow = date.toLocaleDateString('vi-VN', options)
    this.yearNow = date.toLocaleDateString('vi-VN', optionsYear)
  },
  methods: {},
  computed: {
    ...mapState({
      workList(state) {
        return state['importOrders'].workList
      }
    })
  },
  data() {
    return {
      dateNow: '',
      yearNow: '',
      info: {
        test: ''
      }
    }
  }
}
</script>
<style>
.sty_detail {
  font-size: 14px;
}
</style>
